import { gql } from '@apollo/client';

export const GET_INTEGRATION_LINK = gql`
  query getIntegrationLink {
    integration @rest(type: "IntegrationLink", path: "/v4/integrations/init") {
      link
    }
  }
`;
export const GET_INTEGRATIONS = gql`
  query getIntegrations {
    integrations @rest(type: "[Integrations]", path: "/v4/integrations") {
      type
      external_id
      friendly_name
      logo_url
      icon_url
    }
  }
`;

export const GET_EXTERNAL_JOBS = gql`
  query getExternalJobs {
    externalJobs
      @rest(
        type: "[IntegrationExternalJob]"
        path: "/v4/integrations/external-jobs"
      ) {
      id
      name
      status
      integration_id
    }
  }
`;

// SYM-6446: candidates a link would send now, so the link screen can warn first.
export const GET_WAITING_CANDIDATES = gql`
  query getWaitingCandidates($vacancyId: Int!, $integrationId: Int!) {
    waitingCandidates(vacancyId: $vacancyId, integrationId: $integrationId)
      @rest(
        type: "WaitingCandidates"
        path: "/v4/integrations/external-jobs/waiting-candidates?vacancy_id={args.vacancyId}&integration_id={args.integrationId}"
      ) {
      count
      candidates
    }
  }
`;
